import React, {
  useState,
  useEffect,
} from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import {
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';

import categoryOptionsStyle from './categoryOptionsStyle';

import { ObjectType } from '../../types/objectType';

import { namespaces } from '../../i18n/i18n.constants';

import CATEGORY_OPTIONS from '../../assets/categoryOptions';

import { changeParams } from '../../redux/modules/reducer';


export const CategoryOptions = ({ defaultValue, enabled }: ObjectType) => {
  const dispatch = useDispatch();
  const classes = categoryOptionsStyle();
  const { t } = useTranslation(namespaces.common);

  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const inputRequest = async (e: any, value: any) => {
    const params: ObjectType = value ? {
      category: value,
    } : {};
    setSelectedValue(value);
    dispatch(changeParams(params));
  };

  useEffect(() => {
    setSelectedValue(defaultValue);
  }, [defaultValue]);

  return (

    <ToggleButtonGroup
      color="primary"
      exclusive
      className={classes.group}
      value={selectedValue}
      onChange={inputRequest}
      disabled={!enabled}
    >
      <ToggleButton className={classes.toogleButton} value={CATEGORY_OPTIONS.ELECTRICITY}>{t('autocomplete.options.electricity')}</ToggleButton>
      <ToggleButton className={classes.toogleButton} value={CATEGORY_OPTIONS.GAS}>{t('autocomplete.options.gas')}</ToggleButton>

      <ToggleButton className={classes.toogleButton} value={CATEGORY_OPTIONS.NONE}>{t('autocomplete.options.all')}</ToggleButton>
    </ToggleButtonGroup>
  );
};
